import jwt_decode from 'jwt-decode';

const MAGIC_LINK_REQUEST_ONLY_CLAIMS = [
  'magicLinkPlayerState',
  'magicLinkAttribution',
  'magicLinkRequestId',
];

export function decodeAuthTokenPayload(token) {
  const raw = String(token || '').trim();
  if (!raw) return null;
  try {
    const decoded = jwt_decode(raw);
    return decoded && typeof decoded === 'object' ? decoded : null;
  } catch (err) {
    return null;
  }
}

export function hasMagicLinkRequestOnlyClaims(payload) {
  if (!payload || typeof payload !== 'object') return false;
  return MAGIC_LINK_REQUEST_ONLY_CLAIMS.some((claim) =>
    Object.prototype.hasOwnProperty.call(payload, claim),
  );
}

export function classifyAuthToken(token) {
  const payload = decodeAuthTokenPayload(token);
  if (!payload) {
    return { type: 'unknown', payload: null };
  }

  if (hasMagicLinkRequestOnlyClaims(payload)) {
    return { type: 'magic-link-request', payload };
  }

  if (payload.id) {
    return { type: 'session', payload };
  }

  return { type: 'unknown', payload };
}

export function isMagicLinkRequestToken(token) {
  return classifyAuthToken(token).type === 'magic-link-request';
}
